import React, { useState } from "react";
import {
  Form,
  Input,
  DatePicker,
  Table,
  InputNumber,
  Select,
  Upload,
  Button,
  Row,
  Col,
  Card,
  message,
  notification,
  Typography,
  Checkbox,
} from "antd";
import {
  PlusOutlined,
  UploadOutlined,
  DeleteOutlined,
} from "@ant-design/icons";
import RequestHandler from "../../util/RequestHandler";
import { odata } from "../Filters/Helper";
import { useHistory } from "react-router-dom";
import moment from "moment";
import { useEffect } from "react";
import config from "../../util/ApiforContext";
import { useLocation } from "react-router-dom";
import ApprovalButtons from "../Forms/ApprovalButtons";
const { Title, Text } = Typography;
const { Option } = Select;
const { TextArea } = Input;

const UpdateQuote = (props) => {
  const [form] = Form.useForm();
  const history = useHistory();
  const [materialsData, setMaterialsData] = useState({
    data: [],
    loading: false,
  });
  const [rows, setRows] = useState([]);
  const [files, setFiles] = useState([]);
  const [loading, setLoading] = useState(false);
  const [supplierSelect, setSupplierSelect] = useState({
    data: [],
    loading: false,
  });

  const [purchaseRequestSelect, setPurchaseRequestSelect] = useState({
    data: [],
    loading: false,
  });
  const [selectedSupplier, setSelectedSupplier] = useState(null);

  const currencies = [
    { id: 1, code: "TRY", symbol: "₺" },
    { id: 2, code: "USD", symbol: "$" },
    { id: 3, code: "EUR", symbol: "€" },
  ];

  const [selectedCurrency, setSelectedCurrency] = useState(currencies[0]);
  const [materialAllListData, setMaterialAllListData] = useState({
    data: [],
    loading: false,
  });
  const [existingFiles, setExistingFiles] = useState([]);
  const [materlalCategorySelect, setMaterialCategorySelect] = useState({
    data: [],
    loading: false,
  });
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const mode = queryParams.get("mode") || "edit"; // default edit
  const isViewMode = mode === "view";
  const [data, setData] = useState({});
  const [isAdditionalApprovalRequired, setIsAdditionalApprovalRequired] =
    useState(null);

  useEffect(() => {
    // Eğer ID varsa, güncelleme için veriyi çek
    if (props.match.params.id) {
      RequestHandler.get(`/MaterialCategory`).then((response) => {
        setMaterialCategorySelect({
          data: response?.value,
          loading: false,
        });
      });

      RequestHandler.get(`/Quote/GetById/${props.match.params.id}`).then(
        (response) => {
          if (response) {
            const data = response;
            setData(response);
            //#region
            RequestHandler.get(
              `/PurchaseRequest/GetById/${data?.purchaseRequestId}`
            ).then((response) => {
              if (response) {
                const purchaseRequestData = response;
                setPurchaseRequestSelect({
                  data: [
                    {
                      id: purchaseRequestData.id,
                      name: purchaseRequestData.name,
                    },
                  ],
                  loading: false,
                });
              }
            });

            if (data?.supplierId) {
              RequestHandler.get(
                `/Quote/GetBySupplierId/${data?.supplierId}`
              ).then((supplier) => {
                if (supplier) {
                  setSupplierSelect({
                    data: [supplier],
                    loading: false,
                  });
                  setSelectedSupplier(supplier?.name);
                }
              });
            }

            //#endregion

            form.setFieldsValue({
              name: data?.name,
              description: data?.description,
              deliveryDate: data?.deliveryDate
                ? moment(data?.deliveryDate)
                : null,
              id: data?.id,
              supplierId: data?.supplierId,
              purchaseRequestId: data?.purchaseRequestId,
              dueDayCount: data?.dueDayCount,
            });
            setRows(
              (data.quoteItems || []).map((item) => ({
                ...item,
                key: item.id || Date.now() + Math.random(), // benzersiz key
              }))
            );
            // Eğer en az 1 tane item varsa currencyId'yi set et
            if (data.quoteItems && data.quoteItems.length > 0) {
              var currency = currencies.find(
                (c) => c.id === data.quoteItems[0].currencyId
              );
              setSelectedCurrency(currency);
            }
            setExistingFiles(data.files || []);
            const stockIds = (data.quoteItems || [])
              .map((item) => item.stockId)
              .filter(Boolean); // null/undefined olanları çıkar

            if (stockIds.length > 0) {
              // 4. OData filter string (Guid için)
              const filter = `id in (${stockIds
                .map((id) => `'${id}'`)
                .join(",")})`;

              // 5. İlgili Stock kayıtlarını çek
              RequestHandler.get(
                `/Quote/GetStockList?$filter=${encodeURIComponent(filter)}`
              ).then((stockResponse) => {
                if (stockResponse) {
                  setMaterialsData({
                    data: stockResponse,
                    loading: false,
                  });
                } else {
                  setMaterialsData({ data: [], loading: false });
                }
              });
            } else {
              // hiç stockId yoksa boş dön
              setMaterialsData({ data: [], loading: false });
            }
          } else {
            message.error("Talep verileri alınamadı.");
          }
        }
      );
    } else {
      // Uyarı ver
      notification.warning({
        message: "Uyarı",
        description: "Güncelleme için geçerli bir talep kaydı bulunamadı.",
      });
    }
  }, [props.match.params.id]);

  const addRow = () => {
    setRows([
      ...rows,
      {
        key: Date.now(),
        stockId: null,
        name: "",
        stockCode: "",
        quantity: 0,
        unitPrice: 0,
        discount: 0,
        vat: 20, // default 20%
        unit: "",
        materialCategoryId: null,
        netAmount: 0,
        total: 0,
        taxRate: 0,
      },
    ]);
  };

  const updateRow = (key, field, value) => {
    setRows((prev) =>
      prev.map((row) => {
        if (row.key === key) {
          let updatedRow = { ...row };

          // Sayısal alanlar için boşsa 0 ata
          if (
            ["quantity", "unitPrice", "discount", "vat"].includes(field) &&
            (value === null || value === undefined || value === "")
          ) {
            value = 0;
          }

          updatedRow[field] = value;

          // Material seçilince isim, kod, birim otomatik doldur
          if (field === "stockId" && value) {
            const selected = materialsData.data.find((m) => m.id === value);
            if (selected) {
              updatedRow.name = selected.name || "";
              updatedRow.stockCode = selected.stockCode || "";
              updatedRow.unit = selected.unit || "";
              updatedRow.materialCategoryId =
                selected.materialCategoryId || null;
              updatedRow.taxRate = selected.taxRate || 0;
            }
          }

          // NetAmount ve Total yeniden hesapla
          const quantity = updatedRow.quantity || 0;
          const unitPrice = updatedRow.unitPrice || 0;
          const discount = updatedRow.discount || 0;
          const vat = updatedRow.vat || 0;

          const netAmount = quantity * unitPrice - discount;
          const total = netAmount + (netAmount * vat) / 100;

          updatedRow.netAmount = netAmount;
          updatedRow.total = total;

          return updatedRow;
        }
        return row;
      })
    );
  };

  const deleteRow = (key) => {
    setRows((prev) => prev.filter((row) => row.key !== key));
  };

  const columns = [
    {
      title: "Malzeme",
      dataIndex: "stockId",
      width: 180, // genişlik (px)
      render: (value, record) => (
        <Select
          placeholder="(Opsiyonel). En az 2 harf giriniz.."
          value={value}
          allowClear
          showSearch
          onSearch={onMaterialSearch}
          onChange={(val) => updateRow(record.key, "stockId", val)}
          style={{ width: "100%" }}
          filterOption={(input, option) =>
            option.children
              .toLocaleLowerCase("tr-TR")
              .indexOf(input.toLocaleLowerCase("tr-TR")) >= 0 ||
            option.code
              .toLocaleLowerCase("tr-TR")
              .indexOf(input.toLocaleLowerCase("tr-TR")) >= 0
          }
          disabled={isViewMode}
        >
          {materialsData?.data?.map((m) => (
            <Option key={m.id} value={m.id}>
              {m.name}
            </Option>
          ))}
        </Select>
      ),
    },
    {
      title: "Stok Kodu",
      dataIndex: "stockCode",
      render: (value, record) => (
        <Input
          value={value}
          readOnly={true} // Malzeme seçiliyse readonly
          disabled={isViewMode}
        />
      ),
    },
    {
      title: "Kategori",
      dataIndex: "materialCategoryId",
      render: (value, record) => (
        <Form.Item style={{ marginBottom: 0 }}>
          <Select
            placeholder="Kategori"
            value={value}
            allowClear
            disabled={true} // Malzeme seçiliyse readonly
            showSearch
            onSearch={onMaterialCategorySearch}
            onChange={(val) => updateRow(record.key, "materialCategoryId", val)}
            style={{ width: "100%" }}
            filterOption={(input, option) =>
              option.children
                .toLocaleLowerCase("tr-TR")
                .indexOf(input.toLocaleLowerCase("tr-TR")) >= 0
            }
          >
            {materlalCategorySelect?.data?.map((m) => (
              <Option key={m.id} value={m.id}>
                {m.name}
              </Option>
            ))}
          </Select>
        </Form.Item>
      ),
    },
    {
      title: "Miktar",
      dataIndex: "quantity",
      width: 90,
      render: (value, record) => (
        <InputNumber
          min={0}
          value={value}
          onChange={(val) => updateRow(record.key, "quantity", val)}
          style={{ width: "100%" }}
          disabled={isViewMode}
          className="ant-input"
          decimalSeparator=","
          thousandSeparator="."
        />
      ),
    },
    {
      title: "Tevkifat",
      dataIndex: "taxRate",
      key: "taxRate",
      align: "left",
      render: (data) => {
        return "%" + data;
      },
    },
    {
      title: "Birim",
      dataIndex: "unit",
      render: (value, record) => (
        <Input
          value={value}
          readOnly={true} // Malzeme seçiliyse readonly
          onChange={(e) => updateRow(record.key, "unit", e.target.value)}
          disabled={isViewMode}
        />
      ),
    },
    {
      title: "Birim Fiyat",
      dataIndex: "unitPrice",
      width: 110,
      render: (value, record) => (
        <InputNumber
          min={0}
          value={value}
          onChange={(val) => updateRow(record.key, "unitPrice", val)}
          style={{ width: "100%" }}
          formatter={(val) =>
            val !== undefined && val !== null && val !== ""
              ? `${selectedCurrency.symbol} ${Number(val).toFixed(2)}`
              : ""
          }
          parser={(val) => val.replace(/[^0-9.]/g, "")}
          disabled={isViewMode}
          className="ant-input"
          decimalSeparator=","
          thousandSeparator="."
        />
      ),
    },
    {
      title: "İskonto",
      dataIndex: "discount",
      width: 110,
      render: (value, record) => (
        <InputNumber
          min={0}
          value={value}
          onChange={(val) => updateRow(record.key, "discount", val)}
          style={{ width: "100%" }}
          formatter={(val) =>
            val !== undefined && val !== null && val !== ""
              ? `${selectedCurrency.symbol} ${Number(val).toFixed(2)}`
              : ""
          }
          parser={(val) => val.replace(/[^0-9.]/g, "")}
          disabled={isViewMode}
          className="ant-input"
          decimalSeparator=","
          thousandSeparator="."
        />
      ),
    },
    {
      title: "KDV (%)",
      dataIndex: "vat",
      width: 90,
      render: (value, record) => (
        <Select
          value={value}
          onChange={(val) => updateRow(record.key, "vat", val)}
          style={{ width: "100%" }}
          disabled={isViewMode}
        >
          {[0, 1, 8, 10, 20].map((v) => (
            <Option key={v} value={v}>
              {v}
            </Option>
          ))}
        </Select>
      ),
    },
    {
      title: "Net Tutar",
      dataIndex: "netAmount",
      width: 110,
      render: (_, record) => {
        const quantity = record.quantity || 0;
        const unitPrice = record.unitPrice || 0;
        const discount = record.discount || 0;
        const netAmount = quantity * unitPrice - discount;
        return `${selectedCurrency.symbol} ${netAmount.toFixed(2)}`;
      },
    },
    {
      title: "Toplam",
      dataIndex: "total",
      width: 110,
      render: (_, record) => {
        const quantity = record.quantity || 0;
        const unitPrice = record.unitPrice || 0;
        const discount = record.discount || 0;
        const vat = record.vat || 0;
        const netAmount = quantity * unitPrice - discount;
        const total = netAmount + (netAmount * vat) / 100;
        return `${selectedCurrency.symbol} ${total.toFixed(2)}`;
      },
    },
    {
      title: "Sil",
      key: "action",
      width: 60,
      render: (_, record) => (
        <Button
          danger
          type="link"
          icon={<DeleteOutlined />}
          onClick={() => deleteRow(record.key)}
          disabled={isViewMode}
        ></Button>
      ),
    },
  ];

  const onSuccess = () => {
    form.resetFields();
    setFiles([]);
    setTimeout(
      function () {
        history.push(`/quote-list`);
      }.bind(this),
      2000
    );
  };

  const onFinish = (values) => {
    // Hatalı satırları tespit et
    const invalidRows = rows.filter((row) => {
      const hasMaterial = row.stockId || (row.name && row.name.trim() !== "");
      const validQuantity =
        typeof row.quantity === "number" && row.quantity > 0;
      const invalidTotal = row.total <= 0;
      return !hasMaterial || !validQuantity || invalidTotal;
    });

    if (invalidRows.length > 0) {
      invalidRows.forEach((row) => {
        setLoading(false);
        notification.error({
          message: "Hatalı Malzeme Satırı",
          description:
            row.name && row.name.trim() !== ""
              ? `${row.name} satırında eksik veya hatalı bilgi var.`
              : `Malzeme Adı belirtilmemiş satırda eksik veya hatalı bilgi var.`,
          placement: "topRight",
        });
      });
      return; // Hatalıysa devam etme
    }

    const updatedRows = rows.map((row) => ({
      ...row,
      currencyId: selectedCurrency.id,
    }));

    // Her şey uygunsa payload hazırla
    const payload = {
      ...values,
      deliveryDate: values.deliveryDate
        ? values.deliveryDate.format("YYYY-MM-DD")
        : null,
      quoteItemUpdateDtos: updatedRows,
      documentVms: existingFiles,
    };

    const formData = new FormData();

    formData.append("jsonString", JSON.stringify(payload));
    // Files alanı: her dosyayı ayrı ayrı 'Files' olarak append et
    files.forEach((file) => {
      formData.append("files", file.originFileObj);
    });

    // API isteği (axios veya kendi RequestHandler’a göre)
    RequestHandler.put(
      `/Quote`,
      formData,
      true,
      {},
      "multipart/form-data"
    ).then((response) => {
      setLoading(false);
      if (response.success) {
        onSuccess();
      } else {
        setLoading(false);
      }
    });
  };

  const onMaterialSearch = (value) => {
    if (value.length >= 2) {
      setMaterialsData({ data: [], loading: true });

      RequestHandler.get(
        `/Quote/GetStockList?$select=id,name,stockCode,materialCategoryId,materialCategoryName,unit,taxRate&$filter=${odata.contains(
          "name",
          value
        )} or ${odata.contains("stockCode", value)}`
      ).then((res) => {
        setMaterialsData({ data: res, loading: false });
      });
    } else {
      setMaterialsData({ data: [], loading: false });
    }
  };

  const onFinishFailed = (errorInfo) => {
    setLoading(false);
  };

  const onSupplierSearch = (value) => {
    if (value.length >= 2) {
      setSupplierSelect({ data: [], loading: true });

      RequestHandler.get(
        `/Quote/GetSupplierList?$select=id,name,code&$filter=(${odata.contains(
          "name",
          value
        )} or ${odata.contains("code", value)})  and Name ne 'Diğer'`
      ).then((res) => {
        setSupplierSelect({ data: res, loading: false });
      });
    } else {
      setSupplierSelect({ data: [], loading: false });
    }
  };

  const onPurchaseRequestSearch = (value) => {
    if (value.length >= 2) {
      setPurchaseRequestSelect({ data: [], loading: true });

      RequestHandler.get(
        `/Quote/GetPurchaseRequestList?$select=id,name,statusByte&$filter=(${odata.contains(
          "name",
          value
        )} or ${odata.contains(
          "description",
          value
        )})  and Name ne 'Diğer' and statusByte eq 2`
      ).then((res) => {
        setPurchaseRequestSelect({ data: res, loading: false });
      });
    } else {
      setPurchaseRequestSelect({ data: [], loading: false });
    }
  };

  const summary = () => {
    const malHizmetToplam = rows.reduce(
      (sum, r) => sum + (r.quantity || 0) * (r.unitPrice || 0),
      0
    );
    const toplamIskonto = rows.reduce((sum, r) => sum + (r.discount || 0), 0);
    const hesaplananKDV = rows.reduce((sum, r) => {
      const net = (r.quantity || 0) * (r.unitPrice || 0) - (r.discount || 0);
      return sum + net * ((r.vat || 0) / 100);
    }, 0);
    const vergilerDahilToplam = rows.reduce((sum, r) => {
      const net = (r.quantity || 0) * (r.unitPrice || 0) - (r.discount || 0);
      const total = net + net * ((r.vat || 0) / 100);
      return sum + total;
    }, 0);

    const toplamOdenecek = vergilerDahilToplam; // İstersen farklı hesaplama da olabilir.

    return (
      <div style={{ textAlign: "right", marginTop: 12, fontWeight: "bold" }}>
        <div>
          Mal Hizmet Toplam Tutarı: {selectedCurrency.symbol}{" "}
          {malHizmetToplam.toFixed(2)}
        </div>
        <div style={{ marginTop: 8 }}>
          Toplam İskonto: {selectedCurrency.symbol} {toplamIskonto.toFixed(2)}
        </div>
        <div style={{ marginTop: 8 }}>
          Hesaplanan KDV: {selectedCurrency.symbol} {hesaplananKDV.toFixed(2)}
        </div>
        <div style={{ marginTop: 8 }}>
          Vergiler Dahil Toplam Tutar: {selectedCurrency.symbol}{" "}
          {vergilerDahilToplam.toFixed(2)}
        </div>
        <div style={{ marginTop: 8 }}>
          Toplam Ödenecek Tutar: {selectedCurrency.symbol}{" "}
          {toplamOdenecek.toFixed(2)}
        </div>
      </div>
    );
  };

  const onPurchaseRequestChange = (value) => {
    if (!value) {
      // Seçim temizlendiyse rows'u boşalt
      setRows([]);
      return;
    }

    // API çağrısı yapılıyor
    RequestHandler.get(
      `/PurchaseRequest/GetPurchaseRequestItemsByPurchaseRequestId/${value}`
    )
      .then((response) => {
        if (response) {
          const data = response;
          if (Array.isArray(data) && data.length > 0) {
            // Gelen veriyi rows formatına uyarlayalım
            const newRows = data.map((item) => ({
              key: item.id || Date.now(), // id varsa kullan yoksa timestamp
              stockId: item.stockId || null,
              name: item.name || "",
              stockCode: item.stockCode,
              quantity: item.quantity || 0,
              unit: item.unit || "",
              unitPrice: 0, // default sıfır, sonra kullanıcı girecek
              discount: 0,
              vat: 20,
              materialCategoryId: item.materialCategoryId || null,
              taxRate: item.taxRate || 0,
            }));

            setRows(newRows);
            const stockIds = (data || [])
              .map((item) => item.stockId)
              .filter(Boolean); // null/undefined olanları çıkar

            if (stockIds.length > 0) {
              // 4. OData filter string (Guid için)
              const filter = `id in (${stockIds
                .map((id) => `'${id}'`)
                .join(",")})`;

              // 5. İlgili Stock kayıtlarını çek
              RequestHandler.get(
                `/Quote/GetStockList?$filter=${encodeURIComponent(filter)}`
              ).then((stockResponse) => {
                if (stockResponse) {
                  setMaterialsData({
                    data: stockResponse,
                    loading: false,
                  });
                } else {
                  setMaterialsData({ data: [], loading: false });
                }
              });
            } else {
              // hiç stockId yoksa boş dön
              setMaterialsData({ data: [], loading: false });
            }
          } else {
            // Boş liste geldiğinde rows'u temizle
            setRows([]);
          }
        } else {
          // Yanıt beklenmedik ise rows boşalt
          setRows([]);
        }
      })
      .catch((error) => {
        console.error("API çağrısı hatası:", error);
        // Hata durumunda rows'u boşaltabiliriz veya kullanıcıya mesaj gösterebiliriz
        setRows([]);
      });
  };

  const fileDownload = (file) => {
    window.open(
      `${config.apiUrl}/FileDownload/${file}?t=${RequestHandler.getToken()}`
    );
  };

  const onMaterialCategorySearch = (value) => {
    if (value.length >= 2) {
      setMaterialCategorySelect({ data: [], loading: true });

      RequestHandler.get(
        `/MaterialCategory?$select=id,name,code&$filter=(${odata.contains(
          "name",
          value
        )} or ${odata.contains("code", value)})  and Name ne 'Diğer'`
      ).then((res) => {
        setMaterialCategorySelect({ data: res.value, loading: false });
      });
    } else {
      setMaterialCategorySelect({ data: [], loading: false });
    }
  };

  return (
    <>
      <Title level={3}>Teklif Güncelleme</Title>
      <Form
        form={form}
        name="update-quote"
        initialValues={{
          remember: true,
        }}
        onFinish={onFinish}
        onFinishFailed={onFinishFailed}
      >
        <Row justify="center" style={{ padding: 20, paddingLeft: "20%" }}>
          <Col xs={24} md={20} lg={24}>
            <Form form={form} layout="vertical" onFinish={onFinish}>
              <Form.Item name="id" hidden>
                <Input />
              </Form.Item>
              <Row gutter={[16, 16]}>
                {/* Sol taraf */}
                <Col xs={24} md={18}>
                  <Card
                    title={
                      <span style={{ fontWeight: "bold", fontSize: 18 }}>
                        Teklif Bilgileri
                      </span>
                    }
                    bordered={false}
                  >
                    <Form.Item
                      label="Teklif Kodu :"
                      name="name"
                      rules={[
                        { required: true, message: "Lütfen kod giriniz" },
                      ]}
                    >
                      <Input disabled={isViewMode} />
                    </Form.Item>
                    <Form.Item
                      label="Açıklama"
                      name="description"
                      // rules={[{ required: true, message: "Lütfen Açıklama giriniz" }]}
                    >
                      <Input.TextArea rows={3} disabled={isViewMode} />
                    </Form.Item>

                    <Col span={24}>
                      <div style={{ display: "flex", gap: "16px" }}>
                        <Form.Item
                          label="Teslimat Tarihi"
                          name="deliveryDate"
                          rules={[
                            {
                              required: true,
                              message: "Lütfen teslimat tarihini seçiniz",
                            },
                          ]}
                          style={{ flex: 1 }}
                        >
                          <DatePicker
                            format="YYYY-MM-DD"
                            style={{ width: "100%" }}
                            disabledDate={(current) => {
                              return (
                                current && current < moment().startOf("day")
                              );
                            }}
                            disabled={isViewMode}
                          />
                        </Form.Item>

                        <Form.Item
                          label="Vade Gün Sayısı"
                          name="dueDayCount"
                          style={{ flex: 1 }}
                        >
                          <InputNumber
                            min={0}
                            precision={0} // sadece tam sayılar
                            style={{ width: "100%" }}
                            placeholder="Vade Gün Sayısı"
                            disabled={isViewMode}
                            className="ant-input"
                            decimalSeparator=","
                            thousandSeparator="."
                          />
                        </Form.Item>
                      </div>
                    </Col>

                    <Form.Item
                      name="purchaseRequestId"
                      label="Talep :"
                      rules={[
                        { required: true, message: "Lütfen Talep seçiniz." },
                      ]}
                    >
                      <Select
                        allowClear
                        showSearch
                        placeholder="En az 2 harf giriniz.."
                        onSearch={onPurchaseRequestSearch}
                        filterOption={(input, option) =>
                          option.children
                            .toLocaleLowerCase("tr-TR")
                            .indexOf(input.toLocaleLowerCase("tr-TR")) >= 0 ||
                          option.code
                            .toLocaleLowerCase("tr-TR")
                            .indexOf(input.toLocaleLowerCase("tr-TR")) >= 0
                        }
                        loading={supplierSelect.loading}
                        onChange={onPurchaseRequestChange}
                        disabled={isViewMode}
                      >
                        {purchaseRequestSelect?.data?.map((item) => (
                          <Select.Option
                            key={item.id}
                            value={item.id}
                            name={item.name}
                          >
                            {item.name}
                          </Select.Option>
                        ))}
                      </Select>
                    </Form.Item>

                    <Form.Item
                      name="supplierId"
                      label="Tedarikçi :"
                      // rules={[
                      //   { required: true, message: "Lütfen Ana Depo seçiniz." },
                      // ]}
                    >
                      <Select
                        allowClear
                        showSearch
                        placeholder="En az 2 harf giriniz.."
                        onSearch={onSupplierSearch}
                        filterOption={(input, option) =>
                          option.children
                            .toLocaleLowerCase("tr-TR")
                            .indexOf(input.toLocaleLowerCase("tr-TR")) >= 0 ||
                          option.code
                            .toLocaleLowerCase("tr-TR")
                            .indexOf(input.toLocaleLowerCase("tr-TR")) >= 0
                        }
                        loading={supplierSelect.loading}
                        disabled={isViewMode}
                      >
                        {supplierSelect?.data?.map((item) => (
                          <Select.Option
                            key={item.id}
                            value={item.id}
                            code={item.code}
                          >
                            {item.name + " (" + item.code + ")"}
                          </Select.Option>
                        ))}
                      </Select>
                    </Form.Item>
                  </Card>

                  <Card
                    title={
                      <span style={{ fontWeight: "bold", fontSize: 18 }}>
                        Teklif Malzemeleri
                      </span>
                    }
                    bordered={false}
                    style={{ marginTop: 16, width: "125%" }}
                  >
                    <Form.Item
                      label="Para Birimi"
                      name="currency"
                      initialValue={selectedCurrency.code}
                    >
                      <Select
                        value={selectedCurrency.code}
                        onChange={(code) => {
                          const cur = currencies.find((c) => c.code === code);
                          if (cur) setSelectedCurrency(cur);

                          // Aynı zamanda satırların currencyId'sini güncelle (opsiyonel)
                          setRows((prev) =>
                            prev.map((row) => ({
                              ...row,
                              currencyId: cur.id,
                            }))
                          );
                        }}
                        style={{ width: 120 }}
                        disabled={isViewMode}
                      >
                        {currencies.map((cur) => (
                          <Option key={cur.id} value={cur.code}>
                            {cur.code}
                          </Option>
                        ))}
                      </Select>
                    </Form.Item>

                    <Button
                      type="dashed"
                      onClick={addRow}
                      icon={<PlusOutlined />}
                      style={{ marginBottom: 10 }}
                      disabled={isViewMode}
                    >
                      Satır Ekle
                    </Button>
                    <Table
                      columns={columns}
                      dataSource={rows}
                      pagination={false}
                      rowKey="key"
                      scroll={{ x: "max-content" }}
                      footer={summary}
                    />
                  </Card>

                  {/* SATIN ALMA EK ONAY */}
                  {isViewMode && (
                    <Card bordered style={{ marginBottom: 24 }}>
                      <Title level={4}>SATIN ALMA KARARI</Title>
                      <Form layout="vertical">
                        <Form.Item
                          label={
                            <span style={{ fontWeight: "bold" }}>
                              Alım Yapılmasına Karar Verilen Firma
                            </span>
                          }
                          name="kararVerilenFirma"
                        >
                          <p style={{ fontSize: 16 }}>
                            {selectedSupplier || "Henüz tedarikçi seçilmedi"}
                          </p>
                        </Form.Item>

                        <Form.Item
                          label={
                            <span style={{ fontWeight: "bold" }}>
                              Ek Onay Gerekli Mi?
                            </span>
                          }
                        >
                          <div style={{ display: "flex", gap: 16 }}>
                            <Checkbox
                              disabled={
                                data.statusByte != 0 && data.statusByte != 1
                              }
                              checked={isAdditionalApprovalRequired === true}
                              onChange={() => {
                                setIsAdditionalApprovalRequired(true);
                                form.setFieldsValue({
                                  isAdditionalApprovalRequired: true,
                                }); // İstersen form'a da yaz
                              }}
                            >
                              Evet
                            </Checkbox>

                            <Checkbox
                              disabled={
                                data.statusByte != 0 && data.statusByte != 1
                              }
                              checked={isAdditionalApprovalRequired === false}
                              onChange={() => {
                                setIsAdditionalApprovalRequired(false);
                                form.setFieldsValue({
                                  isAdditionalApprovalRequired: false,
                                }); // İstersen form'a da yaz
                              }}
                            >
                              Hayır
                            </Checkbox>
                          </div>
                        </Form.Item>

                        <Form.Item
                          label={
                            <span style={{ fontWeight: "bold" }}>
                              Varsa Ek Görüşler
                            </span>
                          }
                          name="additionalComments"
                        >
                          <TextArea
                            placeholder="Ek görüş yazabilirsiniz..."
                            rows={3}
                            disabled={
                              data.statusByte != 0 && data.statusByte != 1
                            }
                          />
                        </Form.Item>

                        <Text strong>
                          Alım Kararı Veren: {localStorage.getItem("userName")}
                        </Text>
                      </Form>
                    </Card>
                  )}

                  {isViewMode && data.statusByte != 0 && (
                    <Card bordered>
                      <Title level={4}>SATIN ALMA EK ONAY</Title>
                      <Form layout="vertical">
                        <Form.Item
                          label={
                            <span style={{ fontWeight: "bold" }}>
                              Satın Alma Kararı
                            </span>
                          }
                          name="satinAlmaKarari"
                        >
                          <Checkbox.Group
                            style={{ display: "flex", gap: 16 }}
                            disabled={data.statusByte != 1}
                          >
                            <Checkbox value="uygun">Uygundur</Checkbox>
                            <Checkbox value="uygunDegil">
                              Uygun Değildir
                            </Checkbox>
                          </Checkbox.Group>
                        </Form.Item>

                        <Form.Item
                          label={
                            <span style={{ fontWeight: "bold" }}>
                              Varsa Ek Görüşler
                            </span>
                          }
                          name="additionalCommentsExtra"
                        >
                          <TextArea
                            placeholder="Ek görüş yazabilirsiniz..."
                            rows={3}
                            disabled={data.statusByte != 1}
                          />
                        </Form.Item>

                        <Text strong>
                          Ek Onay Veren: {localStorage.getItem("userName")}
                        </Text>
                      </Form>
                    </Card>
                  )}

                  <Card
                    title={
                      <span style={{ fontWeight: "bold", fontSize: 18 }}>
                        Dosyalar
                      </span>
                    }
                    bordered={false}
                    style={{ marginTop: 16 }}
                  >
                    {/* API'den gelen dosyalar */}
                    {existingFiles.length > 0 && (
                      <div style={{ marginBottom: 16 }}>
                        {existingFiles.map((file) => (
                          <div
                            key={file.id}
                            style={{
                              display: "flex",
                              justifyContent: "space-between",
                              alignItems: "center",
                              border: "1px solid #ddd",
                              padding: "8px 12px",
                              marginBottom: 8,
                              borderRadius: 4,
                            }}
                          >
                            <span>{file.fileName.split("\\").pop()}</span>
                            <div>
                              <Button
                                type="link"
                                onClick={() => fileDownload(file.fileName)}
                              >
                                İndir
                              </Button>
                              <Button
                                type="link"
                                danger
                                onClick={() =>
                                  setExistingFiles((prev) =>
                                    prev.filter((f) => f.id !== file.id)
                                  )
                                }
                                hidden={isViewMode}
                              >
                                Sil
                              </Button>
                            </div>
                          </div>
                        ))}
                      </div>
                    )}

                    {/* Yeni dosya yükleme alanı */}
                    <Upload
                      multiple
                      beforeUpload={() => false}
                      onChange={({ fileList }) => setFiles(fileList)}
                      fileList={files}
                    >
                      <Button icon={<UploadOutlined />}>Dosya Yükle</Button>
                    </Upload>
                  </Card>

                  {!isViewMode && (
                    <Row justify="space-between">
                      <Col span={24} style={{ textAlign: "right" }}>
                        <Button
                          type="primary"
                          icon={<PlusOutlined />}
                          htmlType="submit"
                          loading={loading}
                        >
                          Teklif Güncelle
                        </Button>
                      </Col>
                    </Row>
                  )}
                </Col>
              </Row>
            </Form>
          </Col>
        </Row>
        {/* En altta, View Mode’da gösterilecek */}
        {isViewMode && (
          <ApprovalButtons
            entityId={data?.id}
            entityType="quote"
            status={data?.statusByte}
            canApprove={data?.canApprove}
            canReject={data?.canReject}
            canCancel={data?.canCancel}
            isAdmin={data?.isAdmin}
            onSuccess={onSuccess}
            additionalComments={form.getFieldValue("additionalComments")}
            additionalCommentsExtra={form.getFieldValue("additionalComments")}
            form={form}
            documentVms={existingFiles}
            files={files}
            isAdditionalApprovalRequired={isAdditionalApprovalRequired}
          />
        )}
      </Form>
    </>
  );
};

export default UpdateQuote;
